module.exports = __webpack_public_path__ + "assets/img/modal-avatar-c43bb4a6.png";